<h2 mat-dialog-title>{{ dialogData.title | translate }}</h2>
<mat-dialog-content class="mat-typography content">
  <mat-spinner></mat-spinner>
  <div class="dialog-text">
    <span>
      {{ dialogData.text | translate }}
    </span>
  </div>
</mat-dialog-content>
